import { defineComponent } from 'vue'
import type { TypeIncidentInfo } from '#models/type_incident_info'
import { TypeWhenRecord } from '#models/type_when'

export default defineComponent({
  props: {
    incident: {
      type: Object as () => TypeIncidentInfo,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    typeLabel: {
      type: String,
      required: true
    },
    whenLabel: {
      type: String,
      required: true
    },
    addLabel: {
      type: String,
      required: true
    },
    maxEntries: {
      type: Number,
      required: false
    }
  },
  data(props) {
    while (props.incident.history.length < 2)
      props.incident.history.add(new TypeWhenRecord())

    return {
    }
  },
  methods: {
  }
})
